module.exports = __webpack_public_path__ + "img/img_honor11_us@3x.72c90259.png";